import React from "react";

// Data cell for the trips tables (Figma: 15px black Ubuntu Light, 16px padding).
// `align="right"` right-aligns; `plain` drops the text styling for cells that
// hold their own coloured element (the trip-id link, the status pill).
const Td = ({ children, align = "left", plain = false }) => (
  <td
    className={plain ? "" : `font-light ${align === "right" ? "text-right" : ""}`}
    style={plain ? { padding: 16 } : { padding: 16, fontSize: 15, color: "#000" }}>
    {children}
  </td>
);

export default Td;
